import Vue from 'vue'
import App from './App.vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faBomb, faRandom, faBirthdayCake, faSmileBeam} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

import './assets/styles/index.css';

library.add(faBomb);
library.add(faRandom);
library.add(faBirthdayCake);
library.add(faSmileBeam);

Vue.component('icon', FontAwesomeIcon);

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')
